import BannerUpload from '../BannerUpload';
import ChipMultiSelect from '../ChipMultiSelect';
import DatePickerField from '../DatePickerField';
import TournamentPaymentSection from './TournamentPaymentSection';
import { AGE_CATEGORIES, GENDER_CATEGORIES } from '../../lib/tournamentCategories';

const ic = "w-full bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#F97316] focus:ring-2 focus:ring-orange-100 rounded-xl px-4 py-2.5 text-sm outline-none transition-all";
const lc = "block text-sm font-semibold text-gray-700 mb-1.5";
const hc = "text-xs font-semibold tracking-[0.15em] uppercase text-gray-500 pt-2";

export const TournamentBasicsSection = ({ f, onChange, setF }) => (
  <>
    <h3 className={hc}>Basics</h3>
    <div>
      <label className={lc}>Tournament name *</label>
      <input type="text" name="name" value={f.name} onChange={onChange} className={ic} required data-testid="tournament-name-input" />
    </div>

    <div>
      <label className={lc}>Format *</label>
      <select name="format" value={f.format} onChange={onChange} className={ic} required>
        <option value="1v1">1v1</option>
        <option value="3v3">3v3</option>
        <option value="5v5">5v5</option>
      </select>
    </div>

    <div>
      <label className={lc}>Gender category * <span className="text-xs font-normal text-gray-500">(select one or more)</span></label>
      <ChipMultiSelect
        value={f.gender_categories || []}
        onChange={(arr) => setF({ ...f, gender_categories: arr })}
        options={GENDER_CATEGORIES}
        testIdPrefix="gender-chip"
      />
    </div>

    <div>
      <label className={lc}>Age category * <span className="text-xs font-normal text-gray-500">(select one or more)</span></label>
      <ChipMultiSelect
        value={f.age_categories || []}
        onChange={(arr) => setF({ ...f, age_categories: arr })}
        options={AGE_CATEGORIES}
        testIdPrefix="age-chip"
      />
    </div>
  </>
);

export const TournamentLocationSection = ({ f, onChange }) => (
  <>
    <h3 className={hc}>Location</h3>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className={lc}>City *</label>
        <input type="text" name="city" value={f.city} onChange={onChange} className={ic} required />
      </div>
      <div>
        <label className={lc}>State *</label>
        <input type="text" name="state" value={f.state} onChange={onChange} className={ic} required />
      </div>
    </div>

    <div>
      <label className={lc}>Venue *</label>
      <input type="text" name="venue" value={f.venue} onChange={onChange} className={ic} required />
    </div>
  </>
);

export const TournamentScheduleSection = ({ f, setF }) => {
  const upd = (k) => (v) => setF({ ...f, [k]: v });
  return (
    <>
      <h3 className={hc}>Schedule</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={lc}>Registration Opens *</label>
          <DatePickerField
            value={f.registration_opens_at}
            onChange={upd('registration_opens_at')}
            maxDate={f.registration_closes_at || f.starts_at}
            testId="date-registration-opens"
          />
        </div>
        <div>
          <label className={lc}>Registration Closes *</label>
          <DatePickerField
            value={f.registration_closes_at}
            onChange={upd('registration_closes_at')}
            minDate={f.registration_opens_at}
            maxDate={f.starts_at}
            testId="date-registration-closes"
          />
        </div>
        <div>
          <label className={lc}>Tournament Start Date *</label>
          <DatePickerField
            value={f.starts_at}
            onChange={upd('starts_at')}
            minDate={f.registration_closes_at || f.registration_opens_at}
            maxDate={f.ends_at}
            testId="date-starts-at"
          />
        </div>
        <div>
          <label className={lc}>Tournament End Date *</label>
          <DatePickerField
            value={f.ends_at}
            onChange={upd('ends_at')}
            minDate={f.starts_at || f.registration_closes_at}
            testId="date-ends-at"
          />
        </div>
      </div>
      <p className="text-xs text-gray-500 -mt-2">Dates cascade — registration must close on or before tournament start.</p>
    </>
  );
};

export const TournamentMediaSection = ({ f, onChange, onBannerChange, onFocusChange }) => (
  <>
    <h3 className={hc}>Banner</h3>
    <div>
      <label className={lc}>Banner image</label>
      <BannerUpload
        value={f.banner_url}
        focusX={f.banner_focus_x ?? 50}
        focusY={f.banner_focus_y ?? 50}
        onChange={onBannerChange}
        onFocusChange={onFocusChange}
      />
    </div>
  </>
);

export const TournamentContentSection = ({ f, onChange }) => (
  <>
    <h3 className={hc}>Content</h3>
    <div>
      <label className={lc}>Description</label>
      <textarea name="description" value={f.description} onChange={onChange} rows={3} className={ic} />
    </div>
    <div>
      <label className={lc}>Rules *</label>
      <textarea name="rules" value={f.rules} onChange={onChange} rows={4} className={ic} required />
    </div>
    <div>
      <label className={lc}>Prizes *</label>
      <textarea name="prizes" value={f.prizes} onChange={onChange} rows={3} className={ic} required />
    </div>
  </>
);

export { TournamentPaymentSection };
